<app-header></app-header>

<div class="conditions-generales-page">
  <div class="container">
    <!-- En-tête -->
    <div class="header-section">
      <h1 class="main-title">Conditions Générales de Vente</h1>
      <p class="subtitle">Site pdf-to-word.fr</p>
    </div>

    <!-- Accès et utilisation -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Accès et utilisation du site</h2>
        
        <div class="content-text">
          <p>L'accès aux services proposés sur le site pdf-to-word.fr peut être payant. L'accès aux services payants est réservé aux personnes majeures. Si l'utilisateur est mineur, il déclare avoir obtenu l'autorisation préalable d'un représentant légal, lequel s'engage à garantir le respect des présentes conditions générales d'utilisation.</p>
        </div>
      </div>
    </div>

    <!-- Services payants -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Services payants</h2>
        
        <div class="content-text">
          <p>Les tarifs TTC des services payants sont clairement indiqués sur le site avant validation. Le paiement s'effectue par carte bancaire (Carte Bleue, Visa, MasterCard ou American Express).</p>
          
          <div class="highlight-text">
            L'utilisateur peut bénéficier d'un accès de 24 heures à un tarif de 0,50 €, puis d'un abonnement de 14 jours à 19,80 €, renouvelé automatiquement, sauf annulation. L'abonnement permet un accès illimité au service de conversion PDF en Word durant la période active.
          </div>
        </div>
      </div>
    </div>

    <!-- Renouvellement & annulation -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Renouvellement & annulation</h2>
        
        <div class="content-text">
          <p>L'abonnement est sans engagement et peut être résilié à tout moment directement depuis la rubrique Se connecter du site pdf-to-word.fr. Sans résiliation, l'abonnement est renouvelé automatiquement tous les 14 jours au tarif en vigueur.</p>
        </div>
      </div>
    </div>

    <!-- Fonctionnement du service -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Fonctionnement du service</h2>
        
        <div class="content-text">
          <p>Le service permet à l'utilisateur de convertir ses fichiers PDF en documents Word modifiables, 100 % en ligne. L'accès aux fichiers convertis se fait par lien de téléchargement envoyé par email. Le service est accessible depuis tous les appareils compatibles (ordinateur, mobile, tablette).</p>
        </div>
      </div>
    </div>

    <!-- Politique de remboursement -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Politique de remboursement</h2>
        
        <div class="content-text">
          <p>L'utilisateur peut contacter le support pour toute demande de remboursement. Celle-ci sera examinée au cas par cas. Si la demande est acceptée, le remboursement sera effectué sur la carte ayant servi au paiement, dans un délai maximal de 5 jours ouvrés.</p>
        </div>
      </div>
    </div>

    <!-- Droit de rétractation -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Droit de rétractation</h2>
        
        <div class="content-text">
          <div class="warning-text">
            EN TOUT ÉTAT DE CAUSE, UNE FOIS QUE L'UTILISATEUR A CLIQUÉ SUR LE BOUTON DE CONFIRMATION DE LA COMMANDE ENTRAÎNANT L'OBLIGATION DE PAIEMENT, L'ACCÈS AU SERVICE EST IMMÉDIAT ET L'UTILISATEUR PEUT ALORS COMMENCER LA CONVERSION DE SES FICHIERS PDF EN DOCUMENTS WORD.
          </div>
          
          <div class="warning-text">
            EN CONSÉQUENCE, EN APPLICATION DE L'ARTICLE L. 221-28 DU CODE DE LA CONSOMMATION, L'UTILISATEUR DONNE EXPRESSÉMENT SON ACCORD POUR L'EXÉCUTION IMMÉDIATE DU SERVICE ET RENONCE EXPRESSÉMENT À SON DROIT DE RÉTRACTATION POUR TOUTE LA DURÉE DE FOURNITURE DU SERVICE.
          </div>
        </div>
      </div>
    </div>

    <!-- Médiation de la consommation -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Médiation de la consommation</h2>
        
        <div class="content-text">
          <p>Conformément aux articles L. 611-1 et suivants du Code de la consommation, tout litige peut faire l'objet d'une médiation auprès de CM2C. Pour déclarer un litige : <a href="https://cm2c.net/declarer-un-litige.php" target="_blank">https://cm2c.net/declarer-un-litige.php</a></p>
        </div>
      </div>
    </div>

    <!-- Informations de l'entreprise -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Informations légales</h2>
        
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Raison sociale et forme sociale :</span>
            <span class="info-value">SBDI</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Siège social :</span>
            <span class="info-value">2a Connaught Avenue, London, United Kingdom, E4 7AA</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Numéro BRN :</span>
            <span class="info-value">16129808</span>
          </div>
          
          <div class="info-item">
            <span class="info-label">Déclaration de confirmation datée du :</span>
            <span class="info-value">04/08/2025</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Horaires et contact -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Horaires et contact</h2>
        
        <div class="contact-info">
          <div class="customer-service">
            <h3 class="subsection-title">Service client</h3>
            <p>Notre service client se tient à votre disposition, de 9h à 12h et de 13h à 18h du lundi au vendredi, au numéro suivant:</p>
            <div class="phone-number">
              <span class="phone">0 532 183 976</span>
              <span class="phone-details">Service gratuit + prix appel</span>
            </div>
          </div>
          
          <div class="schedule">
            <h3 class="subsection-title">Contact email</h3>
            <p>Pour nous contacter : <a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>